import React from 'react';
import HeaderUno from '../Metodos/Compartidos/HeaderUno';
import HeaderDos from '../Metodos/Compartidos/HeaderDos';

import { Cuerpo, FlexColumn } from '../Css/StyledHeader';
import { Text } from '../Css/StyledPatient';

const Contacto = () => {

    const phoneNumber = "5491157598506";

    return (
        <Cuerpo>

            <HeaderUno />

            <HeaderDos
                link={`/escritorio/pacientes`}
                componente={"CONTACTO"}
                paciente={true}
            />

            <FlexColumn
                align="center"
                justify="center"
            >

                <Text margin="2rem 1rem 0 1rem">

                    ¿Necesitás ayuda?

                    <br />
                    <br />

                    Si tuviste algún inconveniente, querés hacernos una sugerencia o simplemente necesitás comunicarte con nosotros, no dudes en escribirnos. Estamos para ayudarte y siempre agradecemos tus comentarios para seguir mejorando.

                    <br />
                    <br />

                    Podés contactarnos por:

                    <br />
                    <br />

                    Email a soporte@metodoyogen.com

                    <br />
                    <br />

                    <a
                        href={`https://wa.me/${phoneNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}
                    >

                        <img
                            src={`/img/whatsapp.svg`}
                            alt="WhatsApp"
                            style={{
                                width: "7rem",
                                height: "2rem",
                                marginRight: "1rem"
                            }}
                        />

                        <span>
                            o manual +54 9 11 5759-8506
                        </span>

                    </a>

                </Text>

            </FlexColumn>

        </Cuerpo>
    );
};

export default Contacto;